import { MainLayout } from "@/components/MainLayout";
import { Construction } from "lucide-react";

interface PlaceholderPageProps {
  title: string;
  description: string;
  icon?: React.ComponentType<{ className?: string }>;
}

export function PlaceholderPage({ title, description, icon: Icon = Construction }: PlaceholderPageProps) {
  return (
    <MainLayout>
      <div className="container mx-auto py-8">
        <div className="flex flex-col items-center justify-center min-h-[400px] text-center">
          <Icon className="w-16 h-16 text-muted-foreground mb-4" />
          <h1 className="text-3xl font-bold mb-2">{title}</h1>
          <p className="text-foreground max-w-md">{description}</p>
          <p className="text-sm text-muted-foreground mt-4">
            Esta funcionalidade está em desenvolvimento e será implementada em breve.
          </p>
        </div>
      </div>
    </MainLayout>
  );
}

